import { forwardRef } from 'react';
import { ReactKit } from '@team/react';
import { RootComponent } from '../../services/root-component';
import { VisuallyHidden } from '../../services/visually-hidden';
import { Props } from './types';
import css from './style.module.css';

export const Entry = forwardRef<HTMLSpanElement, Props>(function Component(
  { children = 'Загружается...', ...props },
  forwardedRef
) {
  return (
    <RootComponent
      {...props}
      Component="span"
      baseClassName={css.root}
      role="status"
      ref={forwardedRef}
    >
      {ReactKit.hasNode(children) && (
        <VisuallyHidden>{children}</VisuallyHidden>
      )}
    </RootComponent>
  );
});
